/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20.75 3c0-1.6568-1.3431-3-3-3H4.25c-1.6568 0-3 1.3432-3 3v18c0 1.6569 1.3432 3 3 3h13.5c1.6569 0 3-1.3431 3-3v-.25H21c1.5188 0 2.75-1.2312 2.75-2.75v-6c0-1.5188-1.2312-2.75-2.75-2.75h-.25V3Zm-1.5 6.25V3c0-.7692-.5791-1.4033-1.3251-1.49L17.75 1.5H4.25c-.7692 0-1.4033.579-1.49 1.325L2.75 3v6.25h16.5Zm-16.5 11.5V21c0 .7693.579 1.4033 1.325 1.4899l.175.0101h13.5c.7693 0 1.4033-.5791 1.4899-1.3251L19.25 21v-.25H2.75Zm3-14.9973a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm5.188 12.5491H9.6504l-.5142-1.3667H6.3018l-.523 1.3667H4.5L6.9126 12h1.604l2.4214 6.3018Zm-3.2256-5.1197-1.0063 2.6631h2.017l-1.0107-2.6631ZM11.5444 12h2.9532l-.0088.0044c.6548 0 1.1821.2241 1.5864.6724.4043.4482.6064.9536.6064 1.5161 0 .5757-.2021 1.0854-.6064 1.5249-.4043.4394-.9492.6592-1.6304.6592h-1.6743v1.9248h-1.2261V12Zm1.2173 3.2827h1.6348l-.0088-.0088c.3208 0 .5801-.1098.7822-.3252.2022-.2153.3032-.4658.3032-.7514 0-.2857-.0966-.5362-.29-.7515-.1934-.2153-.4351-.3252-.7295-.3252h-1.6919v2.1621Zm6.1908 3.0191H17.7V12h1.2525v6.3018ZM2.75 19.25v-8.5H21c.6904 0 1.25.5596 1.25 1.25v6c0 .6904-.5596 1.25-1.25 1.25H2.75Z"
    clipRule="evenodd"
  />,
  'MenuAPIinfo'
);
